import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/Services/User/user.service';
import { User } from 'src/app/Models/User';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rightbar',
  templateUrl: './rightbar.component.html',
  styleUrls: ['./rightbar.component.scss'],
})
export class RightbarComponent implements OnInit {
  id: any;
  listClub: any;
  nclubs: any;
  Club: any = {};
  constructor(private userservice: UserService, private router: Router) {}

  ngOnInit(): void {
    this.userservice.getAllClub().subscribe(
      (res) => {
        console.log(res);
        this.listClub = res;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getAllClubs() {
    this.userservice.getAllClubScore().subscribe(
      (data) => {
        this.listClub = data;
        this.nclubs = this.listClub.length;
        console.log(data);
        return this.listClub;
      },
      (err) => {
        console.log(err);
      }
    );
  }
}